import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "b196efc1-b1b6-4b7c-980a-90424acab2b5", content: "Phase shift: 0</br>Phase velocity: ∞", options: {} },
  { id: "5abc22a8-c7f7-4bf5-9691-ef40ffbf55bc", content: "Phase shift: π/4</br>Phase velocity: 0 m/s", options: {} },
  { id: "ae868afc-6915-498b-a52f-c7dd865a226f", content: "Phase shift: π/2</br>Phase velocity: 343 m/s", options: {} },
  { id: "8b498a5e-051e-40b2-b849-87a73fc445b2", content: "Phase shift: 2π</br>Phase velocity: 396 m/s", options: {} },
];

export const task: Task = {
  id: "bc9e6c44-64e6-4957-b4e0-cb19b4bfb608",
  solutionType: "select",
  type: "checkbox",
  options: {
    shuffle: true,
    isMultiple: false,
    columns: 1,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["8b498a5e-051e-40b2-b849-87a73fc445b2"],
};
